import type { Store } from '@reduxjs/toolkit'
import { EnvName, selectedCurrentEnv } from '@shared-core/features/env'
import type { AppState } from '@shared-core/store/types'
import { getApiBaseUrl } from './configs/api-base-urls'

let storeRef: Store<AppState> | null = null
// База от платформенного entry: VITE_API_BASE_URL, vite-прокси и т.п.
let baseUrlOverride: string | null = null
// Dev-тумблер "Мок-бэк". Отдельным слоем, чтобы выключение возвращало запросы на базу.
let mockBaseUrl: string | null = null
let apiOriginHint: string | null = null

export function setEnvStore(store: Store<AppState>): void {
  storeRef = store
}

export function setApiBaseUrlOverride(baseUrl: string | null): void {
  baseUrlOverride = baseUrl
}

// null - мок выключен, запросы возвращаются на базовый адрес.
export function setApiMockBaseUrlOverride(baseUrl: string | null): void {
  mockBaseUrl = baseUrl
}

// Реальный origin бэкенда, когда базовый URL пуст (web dev-прокси на localhost):
// нужен для сборки URL поддоменов окружения (myapps и т.п.)
export function setApiOriginHint(origin: string | null): void {
  apiOriginHint = origin
}

export function getEnvName(): EnvName {
  if (!storeRef) {
    return EnvName.production
  }

  const state = storeRef?.getState()
  return selectedCurrentEnv(state) ?? EnvName.production
}

export const getCurrentBaseUrl = (): string => {
  // Мок перекрывает базу: на стендах она задана через VITE_API_BASE_URL.
  if (mockBaseUrl !== null) {
    return mockBaseUrl
  }

  if (baseUrlOverride !== null) {
    return baseUrlOverride
  }

  const envName = getEnvName()

  return getApiBaseUrl(envName)
}

// Origin окружения даже в режиме прокси (getCurrentBaseUrl там — пустая строка)
export const getCurrentApiOrigin = (): string => getCurrentBaseUrl() || apiOriginHint || getApiBaseUrl(getEnvName())
